import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { Grid } from '@mui/material';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import ComplianceSection from '../components/complianceSection';
import FinancialOverviewSection from '../components/FinancialOverviewSection';
import { useSelector } from 'react-redux';
import ScreenLoader from '../../../components/ScreenLoader';
import {usePermissions} from '../../../hooks/usePermissions';
import {
  READ_PURCHASE_INVOICE,
  READ_SALE_INVOICE,
} from '../../../constants/eInvoicePermissions';

const DashboardTabs = () => {
  const {loading, hasEInvoicePermission} = usePermissions();
  const canReadPurchaseInvoices = hasEInvoicePermission(READ_PURCHASE_INVOICE);
  const canReadSalesInvoices = hasEInvoicePermission(READ_SALE_INVOICE);
  const tabs = [
     {
      value: 'compliance',
      label: 'Compliance',
      component: <ComplianceSection canReadSalesInvoices={canReadSalesInvoices} canReadPurchaseInvoices={canReadPurchaseInvoices} />,
    },
    {
      value: 'financial-overview',
      label: 'Financial Overview',
      component: <FinancialOverviewSection canReadSalesAndPurchaseInvoice={canReadSalesInvoices && canReadPurchaseInvoices}/>,
    },
  ].filter(Boolean);

  const [value, setValue] = React.useState(tabs[0]?.value || '');
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Grid>
      <Box sx={{ width: '100%' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="primary"
          indicatorColor="primary"
          aria-label="settings tabs"
        >
          {tabs.map((tab) => (
            <Tab key={tab.value} value={tab.value} label={tab.label} />
          ))}
        </Tabs>

        {tabs.map(
          (tab) =>
            tab.value === value && (
              <Box key={tab.value} sx={{ p: 2 }}>
                {tab.component}
              </Box>
            ),
        )}
      </Box>
    </Grid>
  );
};

export default function DashboardPage() {
  const subscription = useSelector((state) => state.subscription.subscription);
  const reduxLoading = useSelector((state) => state.org.loading);
  useDocumentTitle('Dashboard');
  if (!subscription) {
    return null;
  }
  if (reduxLoading) {
    return <ScreenLoader />;
  }
  return <DashboardTabs />;
}
